import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LS_KEY = 'fp_oraculo_banner_dismissed';

/**
 * OraculoDiscoveryBanner — Tarjeta dismissible en el Inicio que anuncia
 * las features nuevas del Oraculo (audio + glosario) a clientes que aun
 * no las han descubierto.
 *
 * Se oculta cuando:
 *  - Usuario hace click en "Ver Mi Plan" (navega + flag dismissed)
 *  - Usuario hace click en la X (flag dismissed, no se vuelve a mostrar)
 *
 * El flag vive en localStorage. Si quieres resetear: borrar fp_oraculo_banner_dismissed.
 */
export default function OraculoDiscoveryBanner() {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(LS_KEY) === '1'; } catch { return false; }
  });

  if (dismissed) return null;

  const dismiss = () => {
    try { localStorage.setItem(LS_KEY, '1'); } catch {}
    setDismissed(true);
  };

  const goToPlan = () => {
    dismiss();
    navigate('/dashboard/investments');
  };

  return (
    <div className="relative rounded-[20px] p-5 sm:p-6 mb-6 overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #0a2540 0%, #1a3a6c 100%)' }}
    >
      {/* X dismiss */}
      <button
        onClick={dismiss}
        aria-label="Cerrar"
        className="absolute top-3 right-3 w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 text-white/80 hover:text-white flex items-center justify-center text-base"
        type="button"
      >
        ×
      </button>

      <div className="text-[10px] uppercase tracking-wider text-white/60 mb-2 font-semibold">
        🆕 Nuevo en FlowexPay
      </div>
      <div className="text-white font-bold text-lg sm:text-xl mb-1 leading-tight">
        El Oráculo ahora habla
      </div>
      <p className="text-white/85 text-sm leading-relaxed mb-4 max-w-xl">
        Cada análisis de acción y portafolio narrado por voz humana real.
        Y si una palabra financiera no la entiendes, tócala y verás la definición
        con su audio. Aprende invirtiendo sin tener que leer reportes pesados.
      </p>

      <div className="flex flex-wrap gap-2">
        <button
          onClick={goToPlan}
          type="button"
          className="px-4 py-2 bg-white text-[#0a2540] rounded-lg text-sm font-semibold hover:bg-white/90 transition"
        >
          Escuchar mi portafolio →
        </button>
        <button
          onClick={dismiss}
          type="button"
          className="px-4 py-2 bg-white/10 text-white rounded-lg text-sm font-medium hover:bg-white/15 transition"
        >
          Lo descubro yo
        </button>
      </div>
    </div>
  );
}
